import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';
import {APP_CONFIG} from '../../app.config';

@Component({
    standalone: false,
    selector: 'core-block-download-list',
    templateUrl: './block-download-list.component.html',
})

export class BlockDownloadListComponent extends BlockAbstractComponent implements OnInit {
    api = APP_CONFIG.api;

}
